var _g, _circle, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTreasures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_68)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3_68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3164 7C18.5176 7 17.7953 7.47536 17.4794 8.20908L16 11.6452H8C3.58172 11.6452 0 15.2269 0 19.6452V35C0 39.4183 3.58172 43 8 43H40C44.4183 43 48 39.4183 48 35V19.6452C48 15.2269 44.4183 11.6452 40 11.6452H32L30.5206 8.20908C30.2047 7.47536 29.4824 7 28.6836 7H19.3164Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4794 8.20908L14.724 7.02271L14.724 7.02271L17.4794 8.20908ZM16 11.6452V14.6452H17.9746L18.7555 12.8315L16 11.6452ZM32 11.6452L29.2445 12.8315L30.0254 14.6452H32V11.6452ZM30.5206 8.20908L33.276 7.02271L33.276 7.02271L30.5206 8.20908ZM20.2349 9.39546C20.0769 9.76232 19.7158 10 19.3164 10V4C17.3193 4 15.5137 5.18841 14.724 7.02271L20.2349 9.39546ZM18.7555 12.8315L20.2349 9.39546L14.724 7.02271L13.2445 10.4588L18.7555 12.8315ZM8 14.6452H16V8.64516H8V14.6452ZM3 19.6452C3 16.8837 5.23857 14.6452 8 14.6452V8.64516C1.92487 8.64516 -3 13.57 -3 19.6452H3ZM3 35V19.6452H-3V35H3ZM8 40C5.23858 40 3 37.7614 3 35H-3C-3 41.0751 1.92487 46 8 46V40ZM40 40H8V46H40V40ZM45 35C45 37.7614 42.7614 40 40 40V46C46.0751 46 51 41.0751 51 35H45ZM45 19.6452V35H51V19.6452H45ZM40 14.6452C42.7614 14.6452 45 16.8837 45 19.6452H51C51 13.57 46.0751 8.64516 40 8.64516V14.6452ZM32 14.6452H40V8.64516H32V14.6452ZM27.7651 9.39546L29.2445 12.8315L34.7555 10.4588L33.276 7.02271L27.7651 9.39546ZM28.6836 10C28.2842 10 27.9231 9.76232 27.7651 9.39546L33.276 7.02271C32.4863 5.18841 30.6807 4 28.6836 4V10ZM19.3164 10H28.6836V4H19.3164V10Z",
    fill: "#152C5B",
    mask: "url(#path-2-inside-1_3_68)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 6.5,
    stroke: "#FF498B",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 1,
    height: 6,
    transform: "rotate(-90 34 18)",
    stroke: "#152C5B",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreasures);
export default __webpack_public_path__ + "static/media/icon-treasures.684f9a6ead016259db6094ca9f242a9f.svg";
export { ForwardRef as ReactComponent };